<template>
    <CHeader fixed with-subheader light>

        <div :class="$store.state.identity.currentUnit ? 'col-8 no-padding' : 'col-10 no-padding'">
            <CToggler in-header
                      class="ml-3 d-lg-none"
                      @click="$store.commit('toggleSidebarMobile')" />
            <CToggler in-header
                      class="ml-3 d-md-down-none"
                      @click="$store.commit('toggleSidebarDesktop')" />
            <!--<CHeaderBrand class="mx-auto d-lg-none" to="/">
                <CIcon name="logo" height="48" alt="Logo" />
            </CHeaderBrand>-->
            <CHeaderNav class="d-md-down-none mr-auto">
                <CBreadcrumbRouter class="border-0 mb-0" :key="updateBreadcrumbCount" />
                <!--<CHeaderNavItem class="px-3">
                  <CHeaderNavLink to="/dashboard">
                    Dashboard
                  </CHeaderNavLink>
                </CHeaderNavItem>
                <CHeaderNavItem class="px-3">
                  <CHeaderNavLink to="/users" exact>
                    Users
                  </CHeaderNavLink>
                </CHeaderNavItem>
                <CHeaderNavItem class="px-3">
                  <CHeaderNavLink>
                    Settings
                  </CHeaderNavLink>
                </CHeaderNavItem>-->
            </CHeaderNav>
        </div>
        <div :class="$store.state.identity.currentUnit ? 'col-4 no-padding' : 'col-2 no-padding'">
            <CHeaderNav class="mr-4" style="direction: rtl;">
                <!--<CHeaderNavItem class="d-md-down-none mx-2">
                    <CHeaderNavLink>
                        <CIcon name="cil-bell" />
                    </CHeaderNavLink>
                </CHeaderNavItem>
                 -->
                <TheHeaderDropdownAccnt style="direction: ltr;" />
                <TheHeaderDropdownNotification v-if="authorize(['ViewAssetSyncLog','ViewReportSyncLog']) || isAdmin" style="direction: ltr;" />
                <TheHeaderDropdownReportRequestNotification style="direction: ltr;" />
                <CHeaderNavItem style="direction: ltr;" v-if="authorize(['ManageUnit'])" class="mr-3">
                    <CHeaderNavLink to="/master-data/units/national-budget-code-assignment" title="Chuyển mã đơn vị quan hệ ngân sách">
                        <CIcon name="cilBuilding" />
                        <CBadge color="warning" class="ml-auto">{{ availableNationalBudgetCodes }}</CBadge>
                    </CHeaderNavLink>
                </CHeaderNavItem>
                <CHeaderNavItem style="direction: ltr;">
                    <span class="c-header-brand mb-0 text-capitalize font-weight-bold" style="max-width: 200px; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; text-align: left; display: inline-block; vertical-align: middle; line-height: 56px;" :title="$store.state.identity.currentUnit"> {{ $store.state.identity.currentUnit }}</span>
                </CHeaderNavItem>
            </CHeaderNav>
            <!--<CSubheader class="px-3">
                <CBreadcrumbRouter class="border-0 mb-0" />
            </CSubheader>-->
        </div>
    </CHeader>
</template>

<script>
    import TheHeaderDropdownAccnt from './TheHeaderDropdownAccnt'
    import TheHeaderDropdownNotification from './TheHeaderDropdownNotification'
    import TheHeaderDropdownReportRequestNotification from './TheHeaderDropdownReportRequestNotification'
    import { mapState } from 'vuex'
    import { mixins } from '@/shared/mixins'

    export default {
        name: 'TheHeader',
        mixins: [mixins],
        components: {
            TheHeaderDropdownAccnt,
            TheHeaderDropdownNotification,
            TheHeaderDropdownReportRequestNotification
        },
        data() {
            return {
                availableNationalBudgetCodes: 0
            }
        },
        computed: {
            ...mapState({
                updateBreadcrumbCount: (state, getters) => state.common.updateBreadcrumbCount
            })
        },
        mounted() {
            if (this.authorize(['ManageUnit'])) {
                var vm = this;
                this.$services.get(`master-data/available-national-budget-codes/total`).done((data) => vm.availableNationalBudgetCodes = data);
            }
        }
    }
</script>
